import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { isEmptyView } from '../../../utils';

/**
 * [UserMenuHeaderComponent Component](https://brightlayer-ui-components.github.io/angular/?path=/info/components-user-menu--readme)
 *
 * The `<ui-user-menu-header>` is the menu header of the `<ui-user-menu>`.
 */
@Component({
    selector: 'ui-user-menu-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    template: `
        <mat-toolbar
            class="ui-user-menu-header-content"
            [color]="color"
            [class.ui-user-menu-header-no-icon]="isEmpty(iconEl)"
        >
            <div class="ui-user-menu-header-text">
                <div #icon class="ui-user-menu-header-icon-wrapper">
                    <ng-content select="[ui-icon]"></ng-content>
                </div>
                <div *ngIf="title" class="ui-user-menu-header-title-wrapper">
                    <div class="ui-user-menu-header-title">{{ title }}</div>
                    <div *ngIf="subtitle" class="ui-user-menu-header-subtitle mat-subtitle-1">{{ subtitle }}</div>
                </div>
                <ng-content select="[ui-title-content]"></ng-content>
            </div>
        </mat-toolbar>
        <mat-divider *ngIf="divider"></mat-divider>
    `,
    styleUrls: ['./user-menu-header.component.scss'],
    host: {
        class: 'ui-user-menu-header',
    },
})
export class UserMenuHeaderComponent {
    /**
     * Mat toolbar color variant
     *
     * @default primary
     */
    @Input() color: 'primary' | 'accent' | 'warn' | undefined = 'primary';
    /**
     * Show a divider below footer
     *
     * @default false
     */
    @Input() divider = false;
    /** The text to show on the second line */
    @Input() subtitle: string;
    /** The text to show on the first line */
    @Input() title: string;

    @ViewChild('icon', { static: true }) iconEl: ElementRef;

    isEmpty = (el: ElementRef): boolean => isEmptyView(el);
}
